<template>
  <div class="pt-2">
    <NuxtLink
      v-if="url && !isBookingNavigation"
      class="inline-flex items-center gap-1 rounded-lg border border-light-fg-accent px-4 py-2 text-base font-normal leading-6 text-light-fg-accent transition-colors hover:bg-light-bg-inset"
      rel="noopener noreferrer"
      target="_blank"
      :to="url"
      external
      @click="$emit('click', { navType, url, label })"
    >
      {{ displayLabel }}
      <span class="text-xs">→</span>
    </NuxtLink>
    <button
      v-else
      class="inline-flex items-center gap-1 rounded-lg border border-light-fg-accent px-4 py-2 text-base font-normal leading-6 text-light-fg-accent transition-colors hover:bg-light-bg-inset"
      type="button"
      @click="$emit('click', { navType, url, label })"
    >
      {{ displayLabel }}
      <span class="text-xs">→</span>
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  navType: string;
  url?: string;
  label?: string;
}

const props = defineProps<Props>();

defineEmits<{
  click: [payload: { navType: string; url?: string; label?: string }];
}>();

const displayLabel = computed(() => props.label || 'Learn more');
const isBookingNavigation = computed(() => props.navType === 'booking' || props.url === '/reserve');
</script>
